import { Pipe, PipeTransform, inject } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'time',
  pure: false
})
export class TimePipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);

  private static readonly timeSuffixKey = 'default.timeSuffix';

  transform(
    value: Date | string | number | undefined,
    format: 'short' | 'long' | 'noSuffix' = 'short',
  ): string {
    if (!value) return '';

    const date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime())) return '';

    const locale = this.getCurrentLocale();

    if (format === 'noSuffix') {
      return this.formatByLocale(date, locale, {hour: '2-digit', minute: '2-digit'});
    }

    const suffix = this.getSuffix();
    if (format === 'short') {
      return `${this.formatByLocale(date, locale, {hour: '2-digit', minute: '2-digit'})}${suffix}`;
    }

    return `${this.formatByLocale(date, locale, {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    })}${suffix}`;
  }

  private getSuffix(): string {
    const value = this.translateService.instant(TimePipe.timeSuffixKey);
    return value ? ` ${value}` : '';
  }

  private getCurrentLocale(): string | string[] | undefined {
    return this.translateService.currentLang || this.translateService.defaultLang || undefined;
  }

  private formatByLocale(
    date: Date,
    locale: string | string[] | undefined,
    options: Intl.DateTimeFormatOptions,
  ): string {
    return date.toLocaleTimeString(locale, options);
  }

}
